
/**
 * Storefront API
 * ---
 * Details for Storefront API.
 */

const storefrontAccessToken = {
    dev: '752d0f2763effab0c75116b1ab48c516',
    prod_au: '94af83bb5f288f4676821ef899f21f21',
    prod_us: 'dcfe4da65bb157e87f369b4f16fe1da4'
  };
  

  function getAccessToken() {
      let store = window.location.hostname;
      // if AU store
      if(store == 'whitefoxboutique.com.au'){
        return storefrontAccessToken.prod_au;
      // if US store
      }else if(store == 'whitefoxboutique.com'){

        return storefrontAccessToken.prod_us;
      // Otherwise dev store
      }else{
        return storefrontAccessToken.dev;
      }

  }
  
  export const requestConfig = {
    headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': getAccessToken()
    }
  };